'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Stack } from '@s7/layout';
import { Typography } from '@s7/ui';

const titleSx = {
    minHeight: 28
};
const subtitleSx = {
    minHeight: 24
};
const Titles = (props)=>{
    const { title, subtitle } = props;
    return /*#__PURE__*/ jsxs(Stack, {
        justify: "center",
        spacing: "1s",
        children: [
            title && /*#__PURE__*/ jsx(Typography, {
                breakpoints: {
                    'md1.up': {
                        size: [
                            20,
                            24
                        ]
                    }
                },
                size: "md1",
                sx: titleSx,
                variant: "heading",
                preWrap: true,
                children: title
            }),
            subtitle && /*#__PURE__*/ jsx(Typography, {
                size: "md1",
                sx: subtitleSx,
                variant: "text",
                children: subtitle
            })
        ]
    });
};

export { Titles };
//# sourceMappingURL=Titles.js.map
